import { sendRequest } from "../request";
const BASE_URL = '/api/leads';



export function getAllLeads() {
    return sendRequest(`${BASE_URL}`)
}

export function getAllLeadReminders() {
    return sendRequest(`${BASE_URL}/reminders`)
}

export function getLead(leadID) {
    return sendRequest(`${BASE_URL}/${leadID}`)
}

export function createLead(leadData) {
    return sendRequest(`${BASE_URL}/create`, "POST", leadData, 'Invalid Lead Data');
}

export function createLeadReminder(data, userID) {
    return sendRequest(`${BASE_URL}/reminder/${userID}`, "POST", data, 'Unable to Create Reminder');
}

export function updateLead(leadID, leadData) {
    return sendRequest(`${BASE_URL}/${leadID}/update`, "PUT", leadData, 'Unable to Update Lead');
}

export function deleteLead(leadID) {
    return sendRequest(`${BASE_URL}/${leadID}/delete`,"DELETE", null, 'Unable to Delete Lead');
}

export function createLeadTodo(leadID, todoData) {
    return sendRequest(`${BASE_URL}/${leadID}/createTodo`, "PUT", todoData, 'Unable to Create Todo');
}

export function updateLeadTodo(leadID, todoID, data) {
    return sendRequest(`${BASE_URL}/${leadID}/updateTodo/${todoID}`, "PUT", data, 'Unable to Update Todo');
}

export function deleteLeadTodo(leadID, todoID) {
    return sendRequest(`${BASE_URL}/${leadID}/deleteTodo/${todoID}`,"DELETE", null, 'Unable to Delete Todo');
}

export function getLeadsTasks(userID) {
    return sendRequest(`${BASE_URL}/tasks/${userID}`)
}